<template>
  <section
    :class="company?.company_key === 'lloydsestates' && isMobileDevice ? 'tw-h-[85vh]' : 'tw-h-[65vh]'"
    :style="`color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-secondary)'}`"
  >
    <div v-if="variants.v1 === variant" class="w-full">
      <div class="tw-absolute tw-inset-0 -tw-top-16">
        <NuxtImg
          :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
          alt="Background Image"
          class="tw-h-full tw-w-full tw-object-cover tw-object-top"
        />
      </div>
      <div
        class="tw-absolute tw-inset-0 tw-flex tw-items-end tw-justify-center tw-bg-black tw-bg-opacity-20 lg:tw-justify-start"
      >
        <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="700" is="div">
          <h1 class="tw-mb-28 tw-text-center tw-text-white lg:tw-mb-16 lg:tw-ml-28">
            {{ vars.titleText }}
          </h1>
        </MotionGroup>
      </div>
    </div>

    <div v-if="variants.v2 === variant" class="w-full">
      <div class="tw-absolute tw-inset-0">
        <NuxtImg
          :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
          alt="Background Image"
          class="tw-h-full tw-w-full tw-object-cover tw-object-top"
        />
      </div>
      <div
        class="tw-absolute tw-inset-0 tw-opacity-50"
        :style="`background-color: var(--c-${vars.backgroundLayerColor})`"
      ></div>
      <MotionGroup :preset="vars.animationText ? vars.animationText : 'popVisible'" :duration="500" is="div">
        <h1 class="tw-relative tw-z-50 tw-text-center">
          {{ vars.titleText }}
        </h1>
      </MotionGroup>
    </div>

    <div v-if="variants.v3 === variant" class="w-full">
      <div class="tw-absolute tw-inset-0">
        <NuxtImg
          :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
          alt="Background Image"
          class="tw-h-full tw-w-full tw-object-cover tw-object-top"
        />
      </div>
      <div
        class="tw-absolute tw-inset-0 tw-opacity-50"
        :style="`background-color: var(--c-${vars.backgroundLayerColor})`"
      ></div>
      <MotionGroup :preset="vars.animationText ? vars.animationText : 'popVisible'" :duration="500" is="div">
        <div v-html="vars.titleHtml" class="tw-relative tw-z-40 tw-text-white"></div>
      </MotionGroup>
    </div>

    <div v-if="variants.v4 === variant" class="tw-relative tw-flex tw-h-full tw-w-screen tw-items-end">
      <!-- Arka plan -->
      <div class="tw-absolute tw-inset-0">
        <NuxtImg
          :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
          alt="Background Image"
          class="tw-h-full tw-w-full tw-object-cover tw-object-top"
        />
      </div>

      <!-- Katman -->
      <div
        class="tw-absolute tw-inset-0 tw-opacity-50"
        :style="`background-color: var(--c-${vars.backgroundLayerColor})`"
      ></div>

      <!-- İçerik -->
      <MotionGroup
        :preset="vars.animationText ? vars.animationText : 'popVisible'"
        :duration="500"
        is="div"
        class="tw-relative tw-z-10 tw-w-full"
      >
        <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-end tw-gap-6 tw-pb-12 tw-text-center">
          <h1 class="tw-text-white">{{ vars.titleText }}</h1>
          <p class="tw-max-w-2xl tw-text-white">{{ vars.descriptionText }}</p>
          <div class="tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-3 lg:tw-gap-5">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="index"
              :external="true"
              :to="button.link"
              :class="`n-${button.type}`"
            >
              {{ button.label }}
            </nuxt-link>
          </div>
        </div>
      </MotionGroup>
    </div>

    <div v-if="variants.v5 === variant" class="tw-relative tw-flex tw-h-full tw-w-screen tw-items-end">
      <!-- Arka plan -->
      <div class="tw-absolute tw-inset-0">
        <NuxtImg
          :src="isMobileDevice ? vars.mobileBackgroundImage || vars.backgroundImage : vars.backgroundImage"
          alt="Background Image"
          class="tw-h-full tw-w-full tw-object-cover tw-object-top"
        />
      </div>

      <!-- Katman -->
      <div
        class="tw-absolute tw-inset-0 tw-opacity-50"
        :style="`background-color: var(--c-${vars.backgroundLayerColor})`"
      ></div>

      <!-- İçerik -->
      <MotionGroup
        :preset="vars.animationText ? vars.animationText : 'popVisible'"
        :duration="500"
        is="div"
        class="tw-relative tw-z-10 tw-w-full"
      >
        <div
          class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-end tw-gap-6 tw-pb-12 tw-text-center tw-text-white"
        >
          <h1>{{ vars.titleText }}</h1>
          <p class="tw-max-w-2xl">{{ vars.descriptionText }}</p>
          <div class="tw-mt-6 tw-flex tw-items-center tw-justify-center tw-gap-3 lg:tw-gap-5">
            <nuxt-link
              v-for="(button, index) in buttons"
              :key="index"
              :external="true"
              :to="button.link"
              :class="`n-${button.type}`"
            >
              {{ button.label }}
            </nuxt-link>
          </div>
        </div>
      </MotionGroup>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
        v5: 'v5',
      },
    };
  },

  /* props for variant v4 */
  props: {
    component: {
      type: Object,
      required: false,
    },
    version: {
      type: String,
      required: false,
    },
    variables: {
      type: Object,
      required: false,
    },
    tabs: {
      type: Array,
      required: false,
    },
    activeTab: {
      type: String,
      required: false,
    },
  },

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
